import Vue from "vue";
import Router from "vue-router";
// root pages
import Landing from "@/components/Landing";
import Login from "@/components/admin/Login";
import SupplierLogin from "@/components/other-web/supplier/pages/Login";
import ForgotPassword from "@/components/user/ForgotPassword";
import PolicyLayout from "@/components/policy/PolicyLayout";
import Terms from "@/components/policy/Terms";
import Privacy from "@/components/policy/Privacy";
import Consent from "@/components/policy/Consent";
import Content from "@/components/general/Content";
import Redirect from "@/components/general/Redirect";
// layouts
import Dashboard from "@/components/admin/layout/Dashboard";
import ContactLayout from "@/components/admin/layout/ContactLayout";
import ArticleAttendanceLayout from "@/components/admin/layout/ArticleAttendanceLayout";
import HomecareLayout from "@/components/admin/layout/HomecareLayout";
import StaffLayout from "@/components/admin/layout/StaffLayout";
import GreetingLayout from "@/components/admin/layout/GreetingLayout";
import ReportLayout from "@/components/admin/layout/ReportLayout";
import ConferenceDashboard from "@/components/other-web/Conference/pages/ConferenceDashboard";
import ConferenceLayout from "@/components/other-web/Conference/ConferenceLayout";
import ConferenceBookingCreate from "@/components/other-web/Conference/pages/ConferenceBookingCreate";
import ConferenceBookingConfirm from "@/components/other-web/Conference/pages/ConferenceBookingConfirm";
import ConferenceSearchItem from "@/components/other-web/Conference/pages/ConferenceSearchItem";
import OtherLayout from "@/components/other-web/OtherLayout";
import ConferenceBookingDetail from "@/components/other-web/Conference/pages/ConferenceBookingDetail";
import ConferenceSearchCustomerBooking from "@/components/other-web/Conference/pages/ConferenceSearchCustomerBooking";
import ConferenceBookingEditDetail from "@/components/other-web/Conference/pages/ConferenceBookingEditDetail";
import SupplierDashboard from "@/components/other-web/supplier/pages/Dashboard";
import SupplierJobList from "@/components/other-web/supplier/pages/JobList";
import SupplierReportList from "@/components/other-web/supplier/pages/ReportList";
import SupplierJobDetail from "@/components/other-web/supplier/pages/JobDetail";
import SupplierAppointmentList from "@/components/other-web/supplier/pages/AppointmentList";
import SupplierInvoiceDashboard from "@/components/other-web/supplier/pages/InvoiceDashboard";
import SupplierCreateInvoice from "@/components/other-web/supplier/pages/CreateInvoice";
import SupplierInvoiceDetail from "@/components/other-web/supplier/pages/InvoiceDetail";

// features
import AttendanceList from "@/components/admin/view/article/AttendanceList";
import Contact from "@/components/admin/view/contact/Contact";
import ContactProject from "@/components/admin/view/contact/ContactProjects";
import ContactListNew from "@/components/admin/view/contact/ContactListNew";
import HomecareProject from "@/components/admin/view/homecare/HomecareProjects";
import Homecare from "@/components/admin/view/homecare/Homecare";
import Staff from "@/components/admin/view/staff/Staff";
import StaffCreate from "@/components/admin/view/staff/StaffCreate";
import StaffEdit from "@/components/admin/view/staff/StaffEdit";
import Greeting from "@/components/admin/view/greeting/Greeting";
import ReportList from "@/components/admin/view/report/ReportList";
import { NonScFeature } from '../features/nonsc/feature'

// others
import Constant from "@/config/constant";

// fallback
import NotFound from '@/components/general/NotFound'
import Maintenance from '@/components/general/Maintenance';
import { articlesRoutes, bannerRoutes, bannerPinnedRoutes, articlePinnedRoutes } from "../features/articles/routes";
import { subscriptionRoutes } from '../features/subscriptions/routes'
import { managementRoutes } from '../features/managements/routes';
import { communicationRoutes } from '../features/communications/routes'
import { homeAutomationRoutes } from '../features/home-automation/routes'
import { refinanceRoutes } from '../features/refinance/routes'
import { insuranceRoutes } from '../features/insurance/routes'
import { monitoringRoutes } from '../features/monitoring/routes';
import PackageExportRegistrationFormPage from '../features/subscriptions/modules/packages/pages/PackageExportRegistrationFormPage.vue'
import { sellAndRentRoutes } from "../features/sell-and-rent/routes";
import { financialInstitutionRoutes } from "../features/financial-institutions/routes";
import { ruejaiClubRoutes } from "../features/ruejai-club/routes";
import { residentRoutes } from "../features/residents/routes";
import { groupRoutes } from "../features/group/routes";
import { juristicFeatureRoutes } from '../features/juristic-feature/routes';
import { evRoutes } from '../features/ev-parking/routes';
import { leadManagementRoutes } from '../features/lead-management/routes';
import { sapRoutes } from '../features/sap/routes';
import { morningCoinRoutes } from "../features/morning-coin/routes";
import { redeemedMNCRoutes } from '../features/redeemed-mnc/routes'
// ThirdParty
import CovidStatusPage from '@/components/third-party/CovidStatusPage';
import { conferenceRoutes } from "../features/conferences/routes";
import { feedbackRoutes } from "../features/feedbacks/routes";

// Admin Guard
import { AdminGuard } from './admin-guard'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Landing",
      component: Landing
    },
    {
      path: '/redirect-book-service',
      name: "RedirectBookService",
      component: Redirect
    },
    {
      path: '/third-party/covid19',
      name: "CovidStatus",
      component: CovidStatusPage
    },
    {
      path: '/content',
      name: "Content",
      component: Content
    },
    {
      path: '/maintenance',
      name: "Maintenance",
      component: Maintenance
    },
    {
      path: '/admins/packages/:id/registration-forms',
      name: 'PackageExportRegistrationFormPage',
      component: PackageExportRegistrationFormPage
    },
    {
      path: '/admins/logins',
      name: 'Login',
      component: Login
    },
    {
      path: "/admins/",
      name: "Dashboard",
      beforeEnter: AdminGuard.watch,
      component: Dashboard,
      children: [
        subscriptionRoutes,
        managementRoutes,
        communicationRoutes,
        homeAutomationRoutes,
        refinanceRoutes,
        insuranceRoutes,
        sellAndRentRoutes,
        financialInstitutionRoutes,
        monitoringRoutes,
        ruejaiClubRoutes,
        residentRoutes,
        groupRoutes,
        juristicFeatureRoutes,
        evRoutes,
        feedbackRoutes,
        leadManagementRoutes,
        {
          path: "contacts",
          component: ContactLayout,
          meta: {
            breadcrumb: Constant.BREADCRUMB.PROJECT_ALL
          },
          children: [
            {
              path: "/",
              name: "ContactProject",
              component: ContactProject
            },
            {
              path: ":contactId",
              name: "Contact",
              component: Contact,
              meta: {
                breadcrumb: Constant.BREADCRUMB.PROJECT_SELECT
              }
            }
          ]
        },
        {
          path: "contacts-new",
          component: ContactLayout,
          meta: {
            breadcrumb: Constant.BREADCRUMB.PROJECT_ALL
          },
          children: [
            {
              path: "/",
              name: "ContactListNew",
              component: ContactListNew
            },
            {
              path: ":contactId",
              name: "ContactDetailNew",
              component: Contact,
              meta: {
                breadcrumb: Constant.BREADCRUMB.PROJECT_SELECT
              }
            }
          ]
        },
        bannerRoutes,
        bannerPinnedRoutes,
        articlePinnedRoutes,
        articlesRoutes,
        {
          path: "homecare",
          component: HomecareLayout,
          meta: {
            breadcrumb: Constant.BREADCRUMB.PROJECT_ALL
          },
          children: [
            {
              path: "/",
              name: "HomecareProject",
              component: HomecareProject
            },
            {
              path: ":projectId/jobs/:jobId",
              name: "Homecare",
              component: Homecare,
              meta: {
                breadcrumb: Constant.BREADCRUMB.PROJECT_SELECT
              }
            }
          ]
        },
        {
          path: "staffs",
          component: StaffLayout,
          meta: {
            breadcrumb: Constant.BREADCRUMB.ALL
          },
          children: [
            {
              path: "/",
              name: "Staffs",
              component: Staff,
              children: [
                {
                  path: "create",
                  name: "StaffCreate",
                  component: StaffCreate,
                  meta: {
                    breadcrumb: Constant.BREADCRUMB.CREATE
                  }
                },
                {
                  path: ":adminId",
                  name: "StaffEdit",
                  component: StaffEdit,
                  meta: {
                    breadcrumb: Constant.BREADCRUMB.EDIT
                  }
                }
              ]
            }
          ]
        },
        {
          path: "greeting",
          component: GreetingLayout,
          meta: { breadcrumb: Constant.BREADCRUMB.PROJECT_ALL },
          children: [
            {
              path: "/",
              name: "Greeting",
              component: Greeting
            },
            {
              path: ":userId",
              name: "GreetingView",
              component: Greeting
            }
          ]
        },
        {
          path: "reports",
          component: ReportLayout,
          children: [
            {
              path: "/",
              name: "Report",
              component: ReportList
            }
          ]
        },
        sapRoutes,
        morningCoinRoutes,
        conferenceRoutes,
        redeemedMNCRoutes,
        NonScFeature.routes
      ]
    },
    {
      path: "/admins/attendances/",
      component: ArticleAttendanceLayout,
      children: [
        {
          path: ":articleType/:articleId",
          name: "AttendanceList",
          component: AttendanceList
        }
      ]
    },
    {
      path: "/password/reset",
      name: "ForgotPassword",
      component: ForgotPassword
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms
    },
    {
      path: "/policy",
      name: "Policy",
      component: Privacy
    },
    {
      path: "/policy",
      component: PolicyLayout,
      children: [
        {
          name: "PdpaConsent",
          path: "PDPA/consent",
          component: Consent
        },
        {
          name: "Privacy",
          path: "privacy",
          component: Privacy
        },
        {
          name: "Terms",
          path: "terms",
          component: Terms
        }
      ]
    },
    {
      path: "*",
      component: NotFound
    },
    {
      path: "/",
      name: "Others",
      component: OtherLayout,
      children: [
        {
          path: "/conference",
          name: "Conference",
          component: ConferenceLayout,
          children: [
            {
              path: "dashboard",
              name: "DashboardConference",
              component: ConferenceDashboard
            },
            {
              path: "booking/create/:conferenceId",
              name: "BookingCreate",
              component: ConferenceBookingCreate
            },
            {
              path: "booking/confirm/:conferenceId",
              name: "BookingConfirm",
              component: ConferenceBookingConfirm
            },
            {
              path: "search",
              name: "ConferenceSearchItem",
              component: ConferenceSearchItem
            },
            {
              path: "booking/:bookingId",
              name: "ConferenceBookingDetail",
              component: ConferenceBookingDetail
            },
            {
              path: "search/customer",
              name: "ConferenceSearchCustomerBooking",
              component: ConferenceSearchCustomerBooking
            },
            {
              path: "booking/detail/:bookingId",
              name: "ConferenceBookingEditDetail",
              component: ConferenceBookingEditDetail
            },
          ]
        }
      ]
    },
    {
      path: "/partners/logins",
      name: "SupplierLogin",
      component: SupplierLogin
    },
    {
      path: "/partners",
      name: "SupplierDashboard",
      component: SupplierDashboard,
      children: [
        {
          path: "jobs/:navigationMenu",
          name: "SupplierJobList",
          component: SupplierJobList,
        },
        {
          path: "jobs/:navigationMenu/details/:appointmentId",
          name: "SupplierJobDetail",
          component: SupplierJobDetail,
        },
        {
          path: "jobs/:navigationMenu/details/:appointmentId/appointments",
          name: "SupplierAppointmentList",
          component: SupplierAppointmentList
        },
        {
          path: "report/jobs",
          name: "SupplierReportList",
          component: SupplierReportList,
        },
        {
          path: "invoice",
          name: "SupplierInvoiceDashboard",
          component: SupplierInvoiceDashboard
        },
        {
          path: "invoice/create",
          name: "SupplierCreateInvoice",
          component: SupplierCreateInvoice
        },
        {
          path: "invoice/detail/:invoiceId",
          name: "SupplierInvoiceDetail",
          component: SupplierInvoiceDetail
        }
      ],
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js